import PageAbstract from '../PageAbastract'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { loadSpecificBasicInfo } from '@/api/cache'
import { Voyage } from '@/class/model/mdm/Voyage'
import ColumnUtils from '@/utils/ColumnUtils'
import { getContractNoList } from '@/api/seaExport/contractNo'
import lang from '@/lang'
import { getCNptFunc } from '@/api/company'

export default class SeaBookingVessel extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
    this.editVesselVoyageMode = Number(cache.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(cache.config.get('EditVoyageMode'))
    this.showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
    this.vesselList = null
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'vessel': {
        if (!this.vesselList) {
          this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
        }
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.static_data_Vessel,
            cache: false,
            filterable: true,
            allowCreate: false,
            staticOptions: this.vesselList
          }
        }
        const callback = () => this.editInputVesselModel(e.props)
        this.joinFieldWatchList('bookingTerm', callback)
        callback()
        break
      }
      case 'voyageFlight': {
        if (!this.vesselList) {
          this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
        }
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            cache: false,
            filterable: true,
            clearable: true,
            allowCreate: this.editVoyageMode === 1,
            tagName: 'voyageNo',
            tagValue: 'voyageNo',
            filterTagNames: ['voyageNo'],
            staticOptions: []
          },
          convertValue: value => value || ''
        }
        const callback = () => this.getVoyageByVessel(e.props)
        this.joinFieldWatchList('vessel', callback)
        await callback()
        break
      }
      case 'vesselAndVoyage': {
        if (!this.vesselList) {
          this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
        }
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/vessel/vesselAndVoyage'))?.default,
          props: {
            showJudgmentOfVoyageNo: this.showJudgmentOfVoyageNo
          }
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => this.getVoyageByVessel(e.props)
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('vessel', callback)
        jobCallback()
        await callback()
        break
      }
      case 'contractNo': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            cache: false,
            allowCreate: true,
            tagName: 'contractNo',
            tagValue: 'contractNo',
            filterTagNames: ['contractNo'],
            filterable: true,
            clearable: true
          }
        }
        const callback = async() => {
          const customerUuid = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId, 'uuid')
          if (customerUuid) {
            const result = await getContractNoList({ companyUuid: customerUuid, loadType: 'FCL', ignoreEmptyContractNoPrice: true })
            const contractNos = []
            const unqiueSet = new Set()
            for (const item of result.data) {
              if (this.job.etd) {
                if (dateCompare(this.job.etd, item.beginDate) < 0 || dateCompare(this.job.etd, item.endDate) > 0) {
                  continue
                }
              }
              if (unqiueSet.has(item.contractNo)) {
                continue
              }
              contractNos.push(item)
              unqiueSet.add(item.contractNo)
            }
            e.props.staticOptions = contractNos
          } else {
            e.props.staticOptions = []
          }
        }
        this.joinFieldWatchList('customerId', callback)
        this.joinFieldWatchList('etd', callback)
        await callback()
        break
      }
      case 'cNptNo': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/vessel/cnptNo'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = async() => {
          if (this.job.customerId) {
            const result = await getCNptFunc(this.job.customerId)
            e.props.options = result.data
          } else {
            e.props.options = []
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        await callback()
        break
      }
      case 'shippingCompanySpecificCode': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            cache: false,
            allowCreate: true,
            tagName: 'shippingCompanySpecificCode',
            tagValue: 'shippingCompanySpecificCode',
            filterTagNames: ['shippingCompanySpecificCode'],
            filterable: true,
            clearable: true,
            staticOptions: [
              { shippingCompanySpecificCode: lang.t('SeaExport.textiles') },
              { shippingCompanySpecificCode: lang.t('SeaExport.nonTextiles') }
            ]
          }
        }
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }

  /**
   * 编辑船名航次模式
   */
  editInputVesselModel(props) {
    props.allowCreate = false
    switch (this.editVesselVoyageMode) {
      case 1:
        props.allowCreate = true
        break
      case 2:
        if (this.job.bookingTerm !== 'OS') {
          props.allowCreate = true
        } else {
          props.allowCreate = false
        }
        break
      case 3:
        props.allowCreate = false
        break
    }
  }

  async getVoyageByVessel(props) {
    props.staticOptions = []
    if (this.job.vessel && this.vesselList) {
      const vessel = this.vesselList.find(item => item.englishName === this.job.vessel)
      if (vessel) {
        props.staticOptions = await Voyage.getVoyage(vessel.vesselId)
      }
    }
  }
}
